<footer class="container-custom">
  <div class="row footer-row">
    <div class="col-12 col-sm-4">
      <div class="content-politicy-rights">
        <div>
          {{ 'copyright' | i18next }} {{ year }} {{ 'contentPolicy' | i18next }}
        </div>
        <div class="linksContainer">
          <a (click)="onFooterClick('privacy')" class="linksContainer--link">{{
            'privacy' | i18next | uppercase
          }}</a>
          <a (click)="onFooterClick('cookies')" class="linksContainer--link">{{
            'cookies' | i18next | uppercase
          }}</a>
          <a
            target="_blank"
            class="linksContainer--link"
            (click)="openSupportModal()"
            >{{ 'supportContact' | i18next | uppercase }}</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
